module.exports = __webpack_public_path__ + "img/2-1.f3d6ba72.png";